/**
 * Mirrors backend: Agents must not see end-user phone numbers in the admin UI.
 * `staff_user_type` is set from /me (App.js) and login/admin/finish.
 */

export function isAgentStaff() {
  try {
    return localStorage.getItem("staff_user_type") === "Agent";
  } catch {
    return false;
  }
}

export function displayUserPhone(phone) {
  if (isAgentStaff()) return "—";
  if (phone == null || phone === "") return "—";
  return String(phone);
}

/** WhatsApp link only for non-agent staff when phone exists */
export function userPhoneWhatsAppHref(phone) {
  if (isAgentStaff() || phone == null || String(phone).trim() === "") return null;
  return `https://wa.me/${phone}`;
}
